import http from './httpService';
import { apiUrl } from "../config.json";

const apiEndpoint = apiUrl + "/scales"

function scaleUrl(id) {
    return `${apiEndpoint}/${id}`;
  }
  
  export function getScales() {
    return http.get(apiEndpoint);
  }
  
  export function getScale(scaleId) {
    return http.get(scaleUrl(scaleId));
  }
  
  export function saveScale(scale) {
    if (scale.scale_id) {
      const body = { ...scale };
      delete body.scale_id;
      return http.put(scaleUrl(scale.scale_id), body);
    }
  
    return http.post(apiEndpoint, scale);
  }
  
  export function deleteScale(scaleId) {
    return http.delete(scaleUrl(scaleId));
  }
  